import React from 'react'
import Carousel from '../../components/Carousel'
import Image from '../../components/Image'

const ImageGallery = ({ block }) => {
  const imagesData = JSON.parse(decodeURIComponent(block.attrs.gallery))

  return (
    <Carousel
      containScroll="keepSnaps"
      dragFree={false}
      align="start"
      inViewThreshold={0.2}
      slidesToScroll={1}
      autoplay
    >
      {imagesData.map(({ image: { id, url: src, alt } }) => (
        <Image
          key={id}
          alt={alt || ''}
          src={src.replace('http://', 'https://')}
          style={{ margin: 'auto' }}
          className="carousel-item"
        />
      ))}
    </Carousel>
  )
}

export default ImageGallery
